export default __webpack_public_path__ + "static/bratz-x-bb-mobile-ac24c6844c383599ebc51c9f19475262.webp";